export const cents = (value: number | string) =>
  Math.round(Number(value)) as Cents;
export const dollars = (value: number | string) => Number(value) as Dollars;
export const centsToDollars = (c: Cents) => dollars(c / 100);
export const dollarsToCents = (d: Dollars) => cents(d * 100);
export const sanitizeTextCurrency = (text: string) =>
  text.replace(/[^0-9]/g, ""); // text is pennies, so disallow decimal
export const currencyToCents = (text: string) =>
  cents(sanitizeTextCurrency(text));

// A plain signed decimal amount with optional "$" prefix: "5", "$50",
// "5.25", ".25", "-5.25".
const PLAIN_NUMBER = /^[+-]?\$?(?:\d+(?:\.\d*)?|\.\d+)$/;

// A signed amount with optional "$" prefix and correctly comma-grouped
// thousands: "1,000", "$1,000.50", "$1,000,000", etc.
const GROUPED_NUMBER = /^[+-]?\$?\d{1,3}(?:,\d{3})+(?:\.\d*)?$/;

// Parses free-text amount input (e.g. "$1,000.50", " 25 ", "10.10") into cents.
export const parseAmountInputToCents = (text: string): Cents | null => {
  if (typeof text !== "string") return null;
  const trimmed = text.trim();
  if (!PLAIN_NUMBER.test(trimmed) && !GROUPED_NUMBER.test(trimmed)) {
    return null;
  }
  const stripped = trimmed.replace(/[,$]/g, "");
  const value = Number(stripped);
  if (!Number.isFinite(value)) return null;
  return dollarsToCents(dollars(value));
};

export const zeroDollars = dollars(0);
export const zeroCents = cents(0);
